var map = {
	"./ai-analysis.png": 6139,
	"./analysing-autumn-budget-universal-credit-reforms-with-policyengine.webp": 36250,
	"./analysis-of-guaranteed-income-for-the-21st-century.jpg": 33275,
	"./analysis-of-the-spring-budget-2023.jpeg": 47544,
	"./api-v2.webp": 25585,
	"./april-1st-2025.png": 56224,
	"./automate-policy-analysis-with-policy-engines-new-chatgpt-integration.png": 92915,
	"./autumn-budget-2024-employer-nic-pension-contributions.png": 395,
	"./autumn-budget-24-employer-ni.png": 95833,
	"./autumn-budget-24-fuel-duty.png": 49474,
	"./autumn-budget-policy-choices.png": 20421,
	"./behavioural-responses.jpg": 46998,
	"./benefit-uprating-post-pic.jpg": 69918,
	"./biden-budget-2025.jpeg": 68752,
	"./breaking-down-policy-impacts-by-wealth-decile.png": 8158,
	"./breaking-down-poverty-impacts-by-sex.png": 66292,
	"./building-the-roots-of-policyengine-nigeria.webp": 9965,
	"./california-income-tax.png": 45465,
	"./cgt-autumn-budget.jpg": 88364,
	"./charitable-contributions.png": 2892,
	"./citizens-economic-council.png": 57962,
	"./citizens-economic-council_with_title.png": 55544,
	"./classroom-2093744.jpg": 54716,
	"./computing-your-oregon-earned-income-tax-credit.png": 88562,
	"./conservative-2024-manifesto.png": 21644,
	"./dc-financial-support-for-families-with-children.png": 13164,
	"./deeroysterchart1.webp": 49686,
	"./deeroysterchart2.webp": 37346,
	"./deeroysters.png": 57736,
	"./digital-public-goods-alliance-recognizes-policyengine-as-a-digital-public-good.webp": 91920,
	"./district-child-tax-credit.png": 10199,
	"./earth-day-2025.png": 40444,
	"./eitc.webp": 963,
	"./electric-vehicle-tax-credits-under-current-law-and-the-inflation-reduction-act.jpg": 38167,
	"./enhanced-cps-beta.png": 11022,
	"./enhanced-cps-beta_with_title.png": 71515,
	"./enhancing-the-current-population-survey-for-policy-analysis.png": 58539,
	"./estimating-your-supplemental-security-income-benefits-in-policyengine.webp": 84142,
	"./family-first-act.jpg": 30976,
	"./fed_tax_inflation_adjustments.webp": 89454,
	"./fiscalsim.png": 90941,
	"./from-idea-to-impact-scoring-a-policy-reform-on-the-new-policyengine-uk.png": 32540,
	"./from-idea-to-impact-scoring-a-policy-reform-on-the-new-policyengine-us.png": 24926,
	"./from-openfisca-to-policyengine.png": 24481,
	"./givecalc.png": 71699,
	"./harris-ctc.webp": 68317,
	"./harris-eitc.webp": 25847,
	"./how-developers-can-explore-the-policyengine-api.jpg": 15785,
	"./how-machine-learning-tools-make-policyengine-more-accurate.png": 76556,
	"./how-policyengine-estimates-the-effects-of-uk-carbon-taxes.png": 85465,
	"./how-to-simulate-basic-and-guaranteed-income-policies-in-policyengine-us.png": 77143,
	"./how-would-reforms-affect-cliffs.png": 49067,
	"./idaho-2025-tax-change.jpg": 54872,
	"./impact-of-the-chancellors-cost-of-living-support-package.jpg": 402,
	"./income-tax-cuts-rishi-sunak-is-reportedly-considering.webp": 32166,
	"./introducing-2024-election-calculator.png": 28909,
	"./introducing-salternative.png": 46560,
	"./introducing-utah-state-income-tax-analysis-on-policyengine.webp": 55363,
	"./jared-golden.jpeg": 57722,
	"./jeremy-hunt-with-budget-box.jpg": 48970,
	"./jeremy-hunt.jpg": 14253,
	"./jeremy-hunt_with_title.jpg": 65467,
	"./kansas-flat-income-tax-sb-169.webp": 93959,
	"./kansas-income-tax.png": 9050,
	"./kentucky-cuts-income-tax-rate.webp": 57797,
	"./labour-2024-manifesto.png": 13099,
	"./lib-dem-2024-manifesto.jpeg": 28147,
	"./lib-dem-manifesto-2024.jpeg": 29920,
	"./lift-act.jpg": 12343,
	"./louisiana-flat-tax.webp": 59894,
	"./make-everyone-a-policymaker.webp": 96479,
	"./malliotakis-steel-working-families-tax-credit-act.png": 20815,
	"./maryland-standard-deduction.png": 65045,
	"./massachusetts-governor-maura-healeys-fy-2024-budget-recommendation.webp": 49217,
	"./medlock-donation-calculator.png": 1285,
	"./medlock-wins.png": 68779,
	"./michigan-bill-hb4170.jpg": 61626,
	"./mn-hf1938-walz.webp": 22672,
	"./myfriendben-nc.png": 71762,
	"./neo-philanthropy.png": 8217,
	"./new-mexico-income-tax-launch.png": 35470,
	"./new-york-tanf.png": 84483,
	"./niskanen-center-analysis.jpg": 73876,
	"./nta-2024.png": 1347,
	"./ny-hochul-budget.jpg": 44062,
	"./ny-wftc.webp": 28559,
	"./nyc-ctc-s2238.webp": 79438,
	"./obr-forecast-2025.jpg": 92095,
	"./openfisca-wins-edge-of-government-innovation-award.jpeg": 67431,
	"./oregon-rebate.png": 51922,
	"./oregons-nonrefundable-exemption-credit.jpeg": 10321,
	"./pip_and_freeze.jpg": 48293,
	"./policyengine-2022-year-in-review.png": 67440,
	"./policyengine-at-the-basic-income-guarantee-conference-and-the-beeck-centers-rules-as-code-demo-day.jpg": 90394,
	"./policyengine-comes-stateside.webp": 13421,
	"./policyengine-launches-in-new-york-state.webp": 96422,
	"./policyengine-launches-in-washington-state.jpg": 59649,
	"./policyengines-2021-year-in-review.webp": 74296,
	"./poverty-race-ethnicity.jpg": 2894,
	"./prime-minister-liz-trusss-energy-bill-price-cap.jpg": 20610,
	"./projected-impact-of-the-uks-extended-energy-price-guarantee.png": 17350,
	"./raising-the-marriage-allowance-from-10-to-100.jpg": 71476,
	"./reform-uks-emergency-recovery-plan.png": 31720,
	"./rent-relief-act.png": 64186,
	"./restoration-of-the-american-rescue-plan-acts-expanded-child-tax-credit.png": 53303,
	"./rishi-sunaks-proposal-to-cut-the-basic-rate-to-16-percent.jpg": 59474,
	"./social-security-tax-exemption.webp": 72716,
	"./stamp-duties-in-policyengine-uk.jpg": 99630,
	"./state-tax-model-beta.png": 60655,
	"./tax-cuts-in-prime-minister-trusss-growth-plan.png": 89431,
	"./tcja-extension.jpg": 59846,
	"./the-child-tax-credit-in-2023.png": 37977,
	"./the-green-party-manifesto-at-policyfest.webp": 16712,
	"./the-new-policyengine-us-population-impact-page.jpg": 447,
	"./trafwa-ctc.png": 80263,
	"./trafwa-ctc.webp": 51107,
	"./trump-2024.webp": 99264,
	"./two_child_limit.png": 45413,
	"./uk-calibration-dec-2023-update.png": 63631,
	"./uk-household-ai.png": 8822,
	"./uk-nuffield-grant.png": 95276,
	"./uk-pip-reforms.jpg": 36248,
	"./uk-spi-validation.png": 49527,
	"./uk-tax-post.jpg": 30290,
	"./uk-the-new-policyengine.png": 73835,
	"./uk-triple-lock-plus.jpg": 36843,
	"./uk_budget_box_hunt.jpg": 70403,
	"./uk_march_update.png": 4811,
	"./uk_march_update_with_title.png": 2441,
	"./updating-policyengine-to-reflect-snap-reform-in-the-omnibus-bill.webp": 9164,
	"./us-behavioral-response.jpg": 46852,
	"./us-household-ai.png": 95633,
	"./us-the-new-policyengine.png": 19047,
	"./utah-income-tax-changes.jpg": 83105,
	"./vance-ctc.jpg": 75320,
	"./vat-school-comparison-post.jpg": 51423,
	"./winship-individualized-eitc.jpg": 29669,
	"./wyden.jpeg": 89432,
	"./year-in-review-2024.png": 49108,
	"./young-child-exemption-two-child-limit.jpg": 14548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51564;